module.exports = __webpack_public_path__ + "img/criterionimg1.f2dc68fd.png";